module.exports = __webpack_public_path__ + "static/media/loan-id.4205b876.svg";